import React, { useEffect, useState } from "react";
import Main from "../Main";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { CircularProgress } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchRemittersBen, frDeleteBeneficiary, registerRemitterByNum, registerRemitterVerifryOtp } from "../../api/remitterApi";

import { useWallet } from "../../context/walletContext";
import { useSelector } from "react-redux";
import { formatAmount } from "../../utils/formatAmount";

import { useFingerprintCapture } from "../../hooks/useFingerprintCapture";
import { getLocation } from "../../components/Navigator/Navigator";
import { useNotify } from "../../context/NotifyContext";
import { exportTable } from "../../utils/downloadExcel";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import AadhaarModal from "./AadhaarModal";
import FingerprintModal from "../../hooks/FingerprintModal";



const MoneyTransferDMT = () => {
const navigate = useNavigate();
const {walletAmt} = useWallet()
const {
  pidData,
  fpStatus,
  fingerLoading,
  step,
  error,
  captureFingerprint,
  resetFingerprint,
} = useFingerprintCapture();

// const {userInfo} = useSelector(state=>state?.auth)

  const { userInfo, location: savedLocation } = useSelector((s) => s.auth);
const [loading, setLoading] = useState(false);
const [loadingSearch, setLoadingSearch] = useState(false);
const [loadingOtp, setLoadingOtp] = useState(false);
const [searchQuery, setSearchQuery] = useState("");
const [page, setPage] = useState(1);
const [limit] = useState(10);
const [locLoading, setLocLoading] = useState(false);
const [totalPages, setTotalPages] = useState(1);
const [records, setRecords] = useState([]);
const [searchParams, setSearchParams] = useSearchParams();
const initialPhone = searchParams.get("phone") || "";
const [phone, setPhone] = useState('');
const [debouncedSearch, setDebouncedSearch] = useState("");
const { notify } = useNotify();

const [aadhaarNumber, setAadhaarNumber] = useState("");
const [openAadhaarModal, setOpenAadhaarModal] = useState(false);
const [latLong,setLatLong] = useState(null) 

const startEkycFlow = async (aadhaar) => {
  if (!aadhaar || !latLong) {
    return notify("Missing Aadhaar or Location", "error");
  }

  setLoadingOtp(true);

  try {
    // Capture Fingerprint
    const fpPidData = await captureFingerprint("bank2");

    if (!fpPidData) {
      notify("Fingerprint capture failed", "error");
      return;
    }

    const payload = {
      mobile: phone,
      aadhaar_number: aadhaar,
      pidData: fpPidData,
      latitude: latLong.latitude,
      longitude: latLong.longitude,
    };

    const result = await registerRemitterByNum(payload);

    if (result?.success) {
      notify("OTP sent successfully", "success");
      navigate(`/beneficiary/${phone}`);
    } else {
      notify(result?.message || "KYC failed", "error");
    }

  } catch (err) {
    notify("Biometric KYC failed", "error");
  } finally {
    setLoadingOtp(false);
  }
};


// const handleSearchRemitter = async () => {
//   if (!phone) return notify("Phone Number is Required", "error");

//   if (phone.length !== 10)
//     return notify("Phone Number must be 10 digits", "error");

//   setLoadingSearch(true);

//   const params = {
//     page,
//     limit,
//     search: debouncedSearch,
//     mobile: phone,
//   };

//   try {
//     const result = await fetchRemittersBen(params);

//     if (result?.success) {
//       const data = result?.data;
// notify("Remitter Banks List", "success");
//       if (!data) {
//         notify("Remitter not registered!", "error");
//         setRecords([]);
//         return;
//       }

//       setRecords(data || []);
//       setTotalPages(data?.pagination?.totalPages || 1);
//     } else {
//       setRecords([]);
//       notify(result?.message || "Failed to fetch remitter", "error");
//     }
//   } catch (err) {
//     notify("Something went wrong while fetching remitter", "error");
//   } finally {
//     setLoadingSearch(false);
//   }
// };

const handleSearchRemitter = () => {
  handleSearchRemitterWithPhone(phone);
};
const handleSearchRemitterWithPhone = async (mobile) => {
  if (!mobile) return notify("Phone Number is Required", "error");
  if (mobile.length !== 10)
    return notify("Phone Number must be 10 digits", "error");

  setLoadingSearch(true);

  const params = {
    page,
    limit,
    search: debouncedSearch,
    mobile: mobile,
  };

  try {
    const result = await fetchRemittersBen(params);

    if (result?.success) {
      const data = result?.data;
      notify("Remitter Banks List", "success");

      if (!data) {
        notify("Remitter not registered!", "error");
        setRecords([]);
        return;
      }

      setRecords(data || []);
      setTotalPages(data?.pagination?.totalPages || 1);
    } else {
      setRecords([]);
      notify(result?.message || "Failed to fetch remitter", "error");
    }
  } catch {
    notify("Something went wrong while fetching remitter", "error");
  } finally {
    setLoadingSearch(false);
  }
};


// const SendOtpRegisterBeneficiary = async () => {
//   setLoadingOtp(true);
//   try {
//     const location = await getLocation();

//     const payload = {
//       mobile: phone,
//       aadhaar_number: aadhaarNumber,
//       pidData,
//       latitude: location.latitude,
//       longitude: location.longitude,
//     };

//     const result = await registerRemitterByNum(payload);

//     if (result?.success) {
//       notify("OTP sent successfully", "success");
//       navigate(`/beneficiary/${phone}`);
//     } else {
//       notify(result.message, "error");
//       resetFingerprint();
//     }
//   } catch {
//     notify("Something went wrong", "error");
//     resetFingerprint();
//   } finally {
//     setLoadingOtp(false);
//   }
// };


const handleDeleteBank = async (bene_id) => {
  if (!bene_id)
    return notify("Invalid Beneficiary", "error");

  if (phone.length !== 10)
    return notify("Phone Number must be 10 digits", "error");

  setLoading(true);

  const payload = {
    mobile: phone,
    bene_id: bene_id,
  };

  try {
    const result = await frDeleteBeneficiary(payload);

    if (result?.success) {
      notify(result?.message || "Beneficiary deleted successfully", "success");
      setPage(1);
      handleSearchRemitter();
    } else {
      notify(result?.message || "Failed to delete beneficiary", "error");
    }
  } catch (err) {
    notify("Something went wrong!", "error");
  } finally {
    setLoading(false);
  }
};


// const handleAadhaarSubmit = async (aadhaar) => {
//   if (!/^\d{12}$/.test(aadhaar)) {
//     return notify("Enter valid 12 digit Aadhaar", "error");
//   }

//   setAadhaarNumber(aadhaar);
//   setOpenAadhaarModal(false);

//   startEkycFlow(aadhaar); // 👈 MAIN FLOW
// };


const handleAadhaarSubmit = (aadhaar) => {
  if (!/^\d{12}$/.test(aadhaar)) {
    return notify("Enter valid 12 digit Aadhaar", "error");
  }

  setAadhaarNumber(aadhaar);
  setOpenAadhaarModal(false);

  startEkycFlow(aadhaar);
};



const handleAddBeneficiaryClick = async () => {
  if (!phone || phone.length !== 10) {
    return notify("Enter valid phone number", "error");
  }

  try {
    setLocLoading(true); // 🔥 start loader

    // const location = await getLocation();

      let location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

    if (!location?.latitude || !location?.longitude) {
      notify("Location permission required", "error");
      return;
    }

    setLatLong(location);
    setOpenAadhaarModal(true);

  } catch (err) {
    notify("Please allow location", "error");
  } finally {
    setLocLoading(false); // 🔥 stop loader
  }
};

useEffect(() => {
  if (initialPhone && initialPhone.length === 10) {
    setPhone(initialPhone);
    handleSearchRemitterWithPhone(initialPhone);
  }
}, [initialPhone]);


return (
  <Main showRightPanel={false}>
    <div className="mt-4 font-[Poppins]">
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Money Transfer" },
          { label: "Find Remitter & Add Beneficiary" },
        ]}
      />
      {}



      <FingerprintModal open={fingerLoading} step={step} />



      <div className="ds-card p-3 mb-4 mt-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 w-full">
            <img
             src={`${userInfo?.logo}`}
              alt="profile"
              className="h-10 w-10 object-cover rounded-md"
            />
            <div className="flex flex-col w-full">
              {}
              <div className="flex items-center w-full sm:hidden">
                <p className="text-[15px] font-semibold leading-tight text-[var(--text-dark)]">
                  {userInfo?.name}
                </p>
                <p className="font-semibold text-[12px] ml-auto text-[var(--text-dark)]">
                  Avl Bal.
                  <span className="text-[var(--success-color)] font-bold ml-1 text-[14px]">
                    ₹ {formatAmount(walletAmt?.main?.balance)}
                  </span>
                </p>
              </div>
              <p className="sm:hidden text-[12px] font-semibold text-[var(--text-muted)] mt-1">
                ID: {userInfo?.userName}
              </p>
              {}
              <div className="hidden sm:flex items-center gap-2">
                <p className="text-[15px] font-semibold text-[var(--text-dark)]">{userInfo?.name}</p>
                <p className="text-[18px] font-semibold text-[var(--text-muted)]">|</p>
                <p className="text-[15px] font-semibold text-[var(--text-dark)]">
                  ID: {userInfo?.userName}
                </p>
              </div>
            </div>
          </div>
          <div className="hidden sm:block text-right font-semibold text-[15px] whitespace-nowrap text-[var(--text-dark)]">
            Available Balance
            <span className="text-[var(--success-color)] font-bold ml-1">
              ₹ {formatAmount(walletAmt?.main?.balance)}
            </span>
          </div>
        </div>
      </div>
      {}
      <div className="ds-card p-4">
        <div className="flex flex-col sm:flex-wrap sm:flex-row gap-3 w-full">
          <input
            type="text"
            placeholder="Enter Remitter Phone Number"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/[^0-9]/g, ""))
            }
            maxLength={10}
           className="ds-input w-full sm:flex-1 min-w-[140px]"
         
         />
          {}
          {}
<button
  type="button"
  onClick={handleSearchRemitter}
  disabled={loadingSearch}
  className="ds-btn ds-btn-secondary"
  style={{ color: "var(--warning-color)" }}
>
  <SearchRoundedIcon fontSize="small" />
  &nbsp; {loadingSearch ? "Searching..." : "SEARCH REMITTER LIST"}
</button>
<button
  type="button"
  disabled={locLoading}
  onClick={handleAddBeneficiaryClick}
  className="ds-btn ds-btn-ghost border border-[var(--border-color)]"
>
     <AddRoundedIcon fontSize="small" />
  &nbsp;
          {locLoading ? (
    <CircularProgress size={22} color="inherit" />
  ) : (
    "Add Beneficiary"
  )}
</button>



{}
          {}
        <div className="flex gap-3">
            {}
          {}
          <button
            type="button"
            className="ds-action-btn ds-filter-export w-full sm:flex-1 min-w-[140px]"
            onClick={() =>
              exportTable(
                "dmt-beneficiaries",
                [
                  { label: "S.No", value: (_r, i) => (page - 1) * limit + i + 1 },
                  { label: "Beneficiary Name", key: "name" },
                  { label: "Account Number", value: (r) => r.accountNumber || r?.accno || "" },
                  { label: "IFSC Code", key: "ifsc" },
                  { label: "Bene ID", key: "bene_id" },
                ],
                records,
                notify
              )
            }
          >
            <FileDownloadOutlinedIcon fontSize="small" />
            EXPORT TO EXCEL
          </button>
        </div>
          {}
          <div className="w-full sm:flex-1 min-w-[140px] relative">
            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[var(--text-muted)] z-10">
              <SearchOutlinedIcon fontSize="small" />
            </span>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="ds-input w-full pl-8"
               
            />
          </div>
        </div>
        <p className="text-[13px] sm:text-[14px] font-medium mt-4 text-[var(--text-muted)]">
          Beneficiary Accounts List Will Be Available Here For The Searched
          Remitter Number.
        </p>
        {}
                {records?.length > 0 && (
  <div className="mt-5">
    <div className="ds-table-wrap ds-scroll">
      <table className="ds-table text-xs sm:text-sm min-w-[700px]">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Beneficiary Name</th>
            <th>Account Number</th>
            <th>IFSC Code</th>
            <th>Verify Status</th>
            <th>Operations</th>
          </tr>
        </thead>
        <tbody>
          {records.length === 0 ? (
            <tr>
              <td
                colSpan="6"
                className="text-center p-4 text-[var(--text-muted)]"
              >
                No beneficiary accounts found for the searched remitter number.
              </td>
            </tr>
          ) : (
            records.map((row, idx) => (
              <tr key={row.id}>
                <td>{(page-1)*limit + idx + 1}</td>
                <td
                  className="make-text-primary font-semibold cursor-pointer underline"
                  onClick={() => navigate(`/dmt-bank/${row?.bene_id}?phone=${phone}`)}
                >
                  {row?.name}
                </td>
                <td>{row.accountNumber || row?.accno}</td>
                <td>{row.ifsc}</td>
                <td className="text-center">
                  <CheckCircleIcon sx={{ color: "var(--success-color)" }} />
                </td>
                <td onClick={()=>handleDeleteBank(row?.bene_id)}>
                  <button type="button" className="ds-btn ds-btn-secondary !border-[var(--error-color)] !text-[var(--error-color)] text-xs px-3 py-1">
                    DELETE BEN
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
                </div>
                   <div className="flex justify-between items-center mt-3 text-xs w-full text-[var(--text-muted)]">
                     <span>
              Showing {records.length} of {records.length} entries
            </span>
                    <Stack spacing={1}>
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, v) => setPage(v)}
                        variant="outlined"
                        shape="rounded"
                      />
                    </Stack>
                  </div>
           </div>
        )}
      </div>
    </div>
    <AadhaarModal
  open={openAadhaarModal}
  onClose={() => setOpenAadhaarModal(false)}
  onSubmit={handleAadhaarSubmit}
  loading={loadingOtp}
/>

  </Main>
);
};
export default MoneyTransferDMT;
